module.exports = __webpack_public_path__ + "static/media/goblin_swordman.7f56638a.svg";